module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pagination"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.pageNo == 1
    },
    on: {
      "click": function($event) {
        return _vm.$emit('getPageNo', _vm.pageNo - 1)
      }
    }
  }, [_vm._v("\n    上一页\n  ")]), _vm._v(" "), (_vm.startNumAndEndNum.start > 1) ? _c('button', {
    class: {
      active: _vm.pageNo == 1
    },
    on: {
      "click": function($event) {
        return _vm.$emit('getPageNo', 1)
      }
    }
  }, [_vm._v("\n    1\n  ")]) : _vm._e(), _vm._v(" "), (_vm.startNumAndEndNum.start > 2) ? _c('button', [_vm._v("···")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.startNumAndEndNum.end), function(page, index) {
    return (page >= _vm.startNumAndEndNum.start) ? _c('button', {
      key: index,
      class: {
        active: _vm.pageNo == page
      },
      on: {
        "click": function($event) {
          return _vm.$emit('getPageNo', page)
        }
      }
    }, [_vm._v("\n    " + _vm._s(page) + "\n  ")]) : _vm._e()
  }), _vm._v(" "), (_vm.startNumAndEndNum.end < _vm.totalPage - 1) ? _c('button', [_vm._v("···")]) : _vm._e(), _vm._v(" "), (_vm.startNumAndEndNum.end < _vm.totalPage) ? _c('button', {
    class: {
      active: _vm.pageNo == _vm.totalPage
    },
    on: {
      "click": function($event) {
        return _vm.$emit('getPageNo', _vm.totalPage)
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.totalPage) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.pageNo == _vm.totalPage
    },
    on: {
      "click": function($event) {
        return _vm.$emit('getPageNo', _vm.pageNo + 1)
      }
    }
  }, [_vm._v("\n    下一页\n  ")]), _vm._v(" "), _c('button', {
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_vm._v("共 " + _vm._s(_vm.total) + " 条")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c4cf4fea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pagination.vue
// module id = 310
// module chunks = 2